import { useState, useEffect } from 'react';
import MediumEditor from 'medium-editor';
import React, { useRef, useContext } from 'react';
import { TextEditorContext } from './FrameBindingContext';

function TextEditor({ onChange, tag = 'div', html, ...restOfProps }) {
    const editorRef = useRef();
    const ctx = useContext(TextEditorContext);

    useEffect(() => {
        const editor = new MediumEditor(editorRef.current, {
            elementsContainer: ctx?.document?.body,
            ownerDocument: ctx?.document,
            contentWindow: ctx?.window,
            // disableDoubleReturn: true,
            toolbar: {
                buttons: [
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'anchor',
                    'subscript',
                    'superscript',
                    'orderedlist',
                    'unorderedlist',
                    'removeFormat',
                ],
            },
            anchor: {
                targetCheckbox: true,
            },
        });
        editor.subscribe('editableInput', function (event, editable) {
            const content = editor.getContent();

            onChange(content);
        });

        // return () => editor.destroy();
    }, [ctx, onChange, tag]);

    // return (
    // <textarea ref={editorRef} {...restOfProps}>
    //     {html}
    // </textarea>
    // );
    return React.createElement(
        tag,
        restOfProps,
        React.createElement('textarea', {
            className: 'dorik-bcs__me',
            ref: editorRef,
            defaultValue: html,
        })
    );
}

export default TextEditor;
